import type { PageCard } from '@/play/pageTypes'
import { MirrorCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'mirror-draw',
  number: 5,
  title: 'Mirror',
  question: 'Is symmetry under the finger, while drawing, more satisfying than folding to print?',
  status: 'open',
  accent: '#f3d9e6',
  CardArt: MirrorCardArt,
}
